export default "__VITE_ASSET__pNu4JS4y__"